import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import Dashboard from "./Dashboard";
import Landing from "./Landing";

/**
 * `/` gate. Signed-in users get the dashboard. Signed-out visitors get the
 * marketing landing page — unless this device already has anonymous sessions,
 * in which case hiding their work would be worse than skipping the pitch.
 */
export default function Home() {
  const { user, loading } = useAuth();
  const [hasSessions, setHasSessions] = useState(null);

  useEffect(() => {
    if (loading || user) return;
    let alive = true;
    api
      .get("/meetings")
      .then((r) => alive && setHasSessions((r.data || []).length > 0))
      .catch(() => alive && setHasSessions(false));
    return () => {
      alive = false;
    };
  }, [user, loading]);

  if (loading || (!user && hasSessions === null)) {
    return <div className="h-[40vh]" data-testid="home-loading" />;
  }
  if (user || hasSessions) return <Dashboard />;
  return <Landing />;
}
